import script from "./OverviewCards.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewCards.vue?vue&type=script&setup=true&lang=js"

import "./OverviewCards.vue?vue&type=style&index=0&id=090f555e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-090f555e"]])

export default __exports__